export default "__VITE_ASSET__ClgNRYV7__"